// @ts-nocheck
/* eslint-disable */
import React from 'react';
import { PartnerBusinessCard } from './PartnerBusinessCard';
import mapContext from '../../../contexts/map-context';
import type { PartnerBusinessCardProps } from './pbc-types';
import { setFavoritePartner } from '../../../api';
import { ActionTypes } from '../../../contexts/reducers/map-reducer';

export interface Props {
  partnerID: string;
  isMobile: boolean;
  fiveStarRating?: number;
  openDialog: () => void;
  favoritePartner: {
    kvpsid: string;
    tenant: string;
  };
}

const PartnerBusinessCardLoader = ({
  partnerID,
  isMobile,
  fiveStarRating,
  favoritePartner,
  openDialog,
}: Props) => {
  const dispatch = mapContext.useMapDispatch();

  const {
    ctaBarButtonConfig,
    displayCtaBar,
    showOpeningHours,
    fiveStarData,
    dealerReviews,
    ratingSummary,
    myAudiCtaConfig,
    locale,
    accessToken: authService,
    selectedPartner,
    errorMessage,
  } = mapContext.useMapState();

  const flyoutCta = () => {
    openDialog();
    if (ratingSummary || dealerReviews.length) {
      dispatch({ type: ActionTypes.setIsFlyoutOpen, payload: true });
    }
  };

  const setPartner = async (event: React.MouseEvent<HTMLElement>, idFunc: string) => {
    try {
      const favorite = await setFavoritePartner(
        authService,
        locale,
        selectedPartner.kvpsid,
        selectedPartner.tenant,
      );
      const hasError = Object.prototype.hasOwnProperty.call(favorite, 'message');

      if (hasError) {
        dispatch({
          type: ActionTypes.setErrorMessage,
          payload: {
            code: (favorite as { code?: string }).code,
            message: (favorite as { message?: string }).message,
          },
        });
      } else {
        if (idFunc === 'set' && myAudiConfig.setCta.ctaCallback) {
          myAudiConfig.setCta.ctaCallback(event, partnerID);
        } else if (idFunc === 'change' && myAudiConfig.changeCta.ctaCallback) {
          myAudiConfig.changeCta.ctaCallback(event, partnerID);
        }
        dispatch({
          type: ActionTypes.setFavoritePartner,
          payload: favorite,
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  const myAudiConfig = {
    favoritePartner: favoritePartner.kvpsid,
    selectedPartner: selectedPartner.kvpsid,
    setCta: {
      label: myAudiCtaConfig?.setCta?.label ?? '',

      ctaCallback: myAudiCtaConfig?.setCta?.ctaCallback ?? '',
      setFunction: setPartner,
    },
    changeCta: {
      label: myAudiCtaConfig?.changeCta?.label ?? '',

      ctaCallback: myAudiCtaConfig?.changeCta?.ctaCallback ?? '',
      changeFunction: setPartner,
    },
  };

  const pbcProps: PartnerBusinessCardProps = {
    partnerID,
    config: {
      displayOpeningHours: showOpeningHours,
      displayCtaBar,
      displayOfficialName: true,
      displayEmail: true,
      displayPhone: true,
      displayFiveStarRating: fiveStarData.displayFiveStarRating,
      fiveStarRating,
      legalText: fiveStarData.legalText,
      reviews: dealerReviews?.length,
      flyoutCta,
      isLinkedToPWS: true,
      hasOuterSpacing: true,
      isGoogleMapLink: true,
      showImage: !isMobile,
      ctaBarButtonConfig,
      myAudiCtaConfig: myAudiCtaConfig && authService ? myAudiConfig : undefined,
      errorMessage,
      myAudiConfig,
    },
  };

  React.useEffect(() => {
    dispatch({
      type: ActionTypes.setErrorMessage,
      payload: { code: '', message: '' },
    });
  }, [partnerID]);

  return (
    <div data-test-id="partner-business-card-loader-component">
      <PartnerBusinessCard {...pbcProps} data-test-id="sidebar-component" />
    </div>
  );
};

export default React.memo(PartnerBusinessCardLoader);
